import { PropsWithChildren } from "react";

import { css, keyframes } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import { wacToken } from "@/libraries/design/foundations";

export interface ScrollToEnlargeProps extends PropsWithChildren {
    isTransform?: boolean;
}

const scaleUpSm = keyframes({
    from: {
        /* Equivalent to Layout "10" */
        transform: "scale(0.8275)"
    }
});
const scaleUpMd = keyframes({
    from: {
        /* Equivalent to Layout "8" */
        transform: "scale(0.655)"
    },
    to: {
        /* Equivalent to Layout "10" */
        transform: "scale(0.8275)"
    }
});
const transformContainerStyles = css({
    "transformOrigin": "50% 0%",
    [media.above.md]: {
        transform: "scale(0.8275)",
        marginBlockEnd: "-100px"
    },
    "@media (prefers-reduced-motion: no-preference)": {
        [media.above.sm]: {
            animationRange: "exit-crossing 20px exit-crossing 200px",
            animationTimeline: "scroll(block root)",
            animationTimingFunction: wacToken("motion.easing.ease-both"),
            animationFillMode: "backwards"
        },
        [media.only.sm]: {
            animationName: scaleUpSm
        },
        [media.above.md]: {
            animationName: scaleUpMd
        }
    }
});

const dimensionsUpSm = keyframes({
    from: {
        /* Equivalent to Layout "10" */
        width: "82.75%"
    }
});
const dimensionsUpMd = keyframes({
    from: {
        /* Equivalent to Layout "8" */
        width: "65.5%"
    },
    to: {
        /* Equivalent to Layout "10" */
        width: "82.75%"
    }
});
const dimensionsContainerStyles = css({
    "marginInline": "auto",
    [media.above.md]: {
        width: "82.75%"
    },
    "@media (prefers-reduced-motion: no-preference)": {
        [media.above.sm]: {
            animationRange: "exit-crossing 20px exit-crossing 200px",
            animationTimeline: "scroll(block root)",
            animationTimingFunction: wacToken("motion.easing.ease-both"),
            animationFillMode: "backwards"
        },
        [media.only.sm]: {
            animationName: dimensionsUpSm
        },
        [media.above.md]: {
            animationName: dimensionsUpMd
        }
    }
});

export const ScrollToEnlarge = ({
    isTransform = false,
    children
}: ScrollToEnlargeProps) => {
    return (
        <div
            css={[
                isTransform && transformContainerStyles,
                !isTransform && dimensionsContainerStyles
            ]}
        >
            {children}
        </div>
    );
};
